import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";

import CopyButton from "../CopyButton";

const CopiableURL = (props) => {
  const final_url = props.url.replace(" ", "");

  if (!final_url) {
    return null;
  }

  return (
    <>
      <a href={final_url} title={final_url}>
        {props.text}
      </a>
      <CopyToClipboard text={props.url.replace(" ", "")}>
        <CopyButton></CopyButton>
      </CopyToClipboard>
    </>
  );
};

export default CopiableURL;
